import { RichText } from '@sitecore-jss/sitecore-jss-react';
import React, { FC, useContext, useState } from 'react';
import { useTranslation } from 'react-i18next';
import ctaTypes from '../../../../enums/CTA.enums';
import DictionaryTerm from '../../../@shared/dictionaryTerm';
import ModalDialog from '../../../@shared/modalDialog';
import Picture from '../../../@shared/picture';
import ProductDownloadBrochures from '../../../@shared/productDownloadBrochures';
import { TProductDownloadBrochuresDataAssets } from '../../../@shared/productDownloadBrochures/types/productDownloadBrochures.types';
import { FilterContext } from '../../fiilterContext';
import { TBrochure, TModelCard } from '../../types/productPriorModelsWithFilter.types';
import './styles.scss';

const ModelCards: FC<{ cards: TModelCard[] }> = ({ cards = [] }) => {
  const { model } = useContext(FilterContext);
  const [selectedBrochure, setSelectedBrochure] = useState<TBrochure[] | undefined>();
  const { t } = useTranslation();

  if (cards.length === 0) return null;
  return (
    <>
      <div className="model-cards">
        {cards?.map((eachCard) => {
          if (!eachCard) return null;
          return (
            <div key={eachCard?.id} className="model-card">
              <Picture
                productImageProps={{
                  mobileRendition: eachCard?.assets?.[0]?.rendition_desktop_size500,
                  pictureClassName: 'model-card__picture',
                }}
              />
              <div className="model-card__content">
                <p className="model-card__eyebrow">{eachCard.eyebrow}</p>
                <h3 className="model-card__title">{eachCard.title}</h3>
                {eachCard.summarySpecs?.slice(0, 2)?.map(({ key, value }) => (
                  <div className="model-card__specs" key={key}>
                    <RichText tag="div" field={{ value: key }} className="model-card__specs-key" />
                    <RichText tag="div" field={{ value: value }} className="model-card__specs-value" />
                  </div>
                ))}
              </div>
              <div className="model-card__cta-wrapper" onClick={() => setSelectedBrochure(eachCard.brochures)}>
                <div className={`button ${ctaTypes['primaryOrange']} model-card__cta`}>
                  <DictionaryTerm keyword="cnhi-model-cta" />
                </div>
              </div>
            </div>
          );
        })}
      </div>

      <ModalDialog
        close={() => {
          setSelectedBrochure(undefined);
        }}
        isOpen={!!selectedBrochure}
        className="brochures-modal"
      >
        <ProductDownloadBrochures
          fields={{
            itemData: {
              ...model.brochuresItemData(),
            },
            apiData: {
              id: 'filter-modal-model-brochures',
              title: '',
              componentType: '',
              innerComponents: [],
              brochures: {
                assets: selectedBrochure as TProductDownloadBrochuresDataAssets[],
                title: t('cnhi-modal-brochures-title'),
                eyebrow: t('cnhi-modal-brochures-eyebrow'),
                description: t('cnhi-modal-brochures-description'),
              },
            },
          }}
          shouldDownloadOnClick={true}
          shouldAppendRootToSubtitleLinks={false}
        />
      </ModalDialog>
    </>
  );
};

export default ModelCards;
